import WebServiceRequestForTicket from "@/libs/Api/WebServiceRequestForTicket";

class TicketCreateRequest extends WebServiceRequestForTicket {
  constructor(context) {
    super(context);
    super.setTag("Ticket/CreateTicket");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class TicketReplyRequest extends WebServiceRequestForTicket {
    constructor(context) {
        super(context);
        super.setTag("Tickets/Answer/Answer");
    }

    setParams(data) {
        super.setRequestParamDataObj(data);
    }
}

class TicketDeleteRequest extends WebServiceRequestForTicket {
  constructor(context) {
    super(context);
  }
  setId(id) {
    super.setTag("Ticket/DeleteTicket?ticketId=" + id);
  }
}

class TicketGetAllByParentIdRequest extends WebServiceRequestForTicket {
  constructor(context) {
    super(context);
      super.setMethod('GET')
  }

    setId(ticketId) {
        super.setTag(`Tickets/Get/${ticketId}`);
  }
}

class TicketGetAllRequest extends WebServiceRequestForTicket {
  constructor(context) {
    super(context);
      super.setMethod('GET')
      super.setTag('Tickets/GetTickets');
  }
  setParams(data) {
      super.setRequestParam(data)
  }
}
export {
  TicketCreateRequest,
  TicketDeleteRequest,
    TicketGetAllByParentIdRequest,
    TicketReplyRequest,
  TicketGetAllRequest,
};
